import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import Currency from "@mapmycustomers/shared/types/Currency";
import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import CustomMetric, {
  CustomMetricAggregation,
} from "@mapmycustomers/shared/types/stackRank/CustomMetric";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { isCustomField } from "@app/util/fieldModel/impl/assert";

export const getRankingFieldAndAggregation = (
  metric: CustomMetric
): { aggregation: CustomMetricAggregation; field: IField } | undefined => {
  const fieldModel = getFieldModelByEntityType(metric.tableName);
  if (!fieldModel) {
    return;
  }

  const keys = Object.keys(metric.aggs) as CustomMetricAggregation[];
  if (keys.length !== 1) {
    return;
  }

  const aggregation = keys[0];
  const fieldName = metric.aggs[aggregation].length ? metric.aggs[aggregation][0] : undefined;
  const field = fieldName ? fieldModel.getByPlatformName(fieldName) : undefined;
  if (!field || !field.isReadable) {
    return undefined;
  }
  return { aggregation, field };
};

export const convertCustomMetricIntoCustomField = (
  metric: CustomMetric,
  defaultCurrencyId: Currency["id"]
): CustomField | undefined => {
  const aggregationField = getRankingFieldAndAggregation(metric);
  if (!aggregationField) {
    return;
  }

  const { field } = aggregationField;

  return {
    id: metric.id,
    createdAt: new Date(),
    crmPropertyKey: "",
    currencyId: isCustomField(field) ? field.customFieldData.currencyId : defaultCurrencyId,
    dataType: isCustomField(field)
      ? field.customFieldData.dataType
      : field.hasFeature(FieldFeature.MONETARY_VALUE)
        ? CustomFieldDataType.MONETARY
        : CustomFieldDataType.DECIMAL,
    defaultValue: [],
    description: null,
    displayName: metric.name,
    displayOrder: 10000,
    displayType: isCustomField(field) ? field.customFieldData.displayType : null,
    entity: metric.tableName,
    esKey: metric.name,
    options: [],
    placeholder: null,
    updatedAt: new Date(),
  };
};
